import ClientDeliveryListItem from '@/models/ClientDeliveryListItem';

export default {
  /**
   * Transforma un solo objeto JSON del backend a tu Modelo JS
   */
  fromJson(json) {
    if (!json) return new ClientDeliveryListItem();

    return new ClientDeliveryListItem({
      salesOrderId: json.sales_order_id,
      folio: json.folio,
      clientName: json.client_name,
      storeName: json.store_name,
      totalItemsOrdered: json.total_items_ordered,
      totalItemsPending: json.total_items_pending,
      purchaseDate: json.purchase_date,
      statusId: json.status_id,
      statusDescription: json.status_description,
    });
  },

  /**
   * Transforma un arreglo completo de JSONs (Lo que usamos para la tabla)
   */
  fromJsonList(jsonList) {
    if (!Array.isArray(jsonList)) return [];
    return jsonList.map((json) => this.fromJson(json));
  },
};
